import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalWindow from "../../shared/ModalWindow";

import style from "./style.module.scss";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import { Order, User } from "../../../services";
import cn from "classnames";
import { toast } from "react-toastify";
import Loading from "../../shared/Loading/Loading";
import { useSelector } from "react-redux";
import { requestErrorDisplay } from "../../../utils";
import CustomSelect from "../../custom/custom-select";
import CustomInput from "../../custom/custom-input/CustomInput";
import AddAddress from "./components/AddAddress";
import { useLanguage } from "../../../context/LanguageContext";
import MapAddressPicker from "./components/MapAddressPicker/MapAddressPicker";
import CustomPhoneInput from "../../custom/custom-phone-input/CustomPhoneInput";
import { getCountryById } from "../../../utils/countryPhoneData";

const COUNTRIES_WITH_MAP_ADDRESS = [
  "63556b49614a6ddc9ceeb61e", // Казахстан
  "65c0d133b6291f8c2e12cccb", // Азербайджан
  "6571605d90729eb27c0597d9", // Кыргызстан
  "63556bc1614a6ddc9ceeb61f", // Россия
  "6571607990729eb27c0597dc", // Туркменистан
  "648b0836d64a46fc66c74273", // Узбекистан
  "67ab3087b8687dc296bba560", // Беларусь
  "6862fc072f3cf1a32ade5165", // Таджикистан
];

const OrdersLocationAddModal = ({
  onClose,
  updateContent,
  searchText = "",
  titleEnd = "",
  displayBin = false,
  isSender = false,
  isRailway = false,
  setLoadingAddress = false,
  countries = [],
  countrySelected,
  citySelected,
  onChangeCity,
  onChangeCountry,
}) => {
  const { t } = useTranslation();
  const locationContext = isRailway ? "railway" : undefined;
  const { user } = useSelector((state) => state);
  const company = useSelector((state) => state.user.company);
  const { currentLanguage } = useLanguage();
  const [name, setName] = useState(null);
  const [country, setCountry] = useState(countrySelected);
  const [binData, setBinData] = useState();
  const [cities, setCities] = useState();
  const [city, setCity] = useState(citySelected);
  const [address, setAddress] = useState(searchText || null);
  const [coordinates, setCoordinates] = useState();
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const phoneCountry = getCountryById(countrySelected?.id, t);

  useEffect(() => {
    if (user?.id && isSender) {
      // setPhone(user?.phoneNumber || null);
      setName(company?.name || null);
    }
    setEmail(user?.email || null);
  }, [user, isSender, company]);

  useEffect(() => {
    if (country?.id) {
      Order.getCities(currentLanguage, country.id)
        .then((response) => {
          console.log("cities 111", country, response);
          setCities(
            response.data.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            }),
          );
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    } else {
      setCities([]);
    }
  }, [country]);

  const validationData = () => {
    setErrors(null);
    const newErrors = {};
    let allow = true;

    if (!name) {
      toast.error(t("ordersLocationAddModal.validation.recipientNameRequired"));
      newErrors.name = t("ordersLocationAddModal.validation.enterName");
      allow = false;
    }
    // if (!phone) {
    //   toast.error(t("ordersLocationAddModal.validation.phoneRequired"));
    //   newErrors.phone = t("ordersLocationAddModal.validation.enterPhone");
    //   allow = false;
    // }
    // const isMapAddressCountry = COUNTRIES_WITH_MAP_ADDRESS.includes(country?.id);

    // if (isMapAddressCountry && !coordinates) {
    //   toast.error(t("ordersLocationAddModal.validation.coordinatesMissing"));
    //   newErrors.address = t("ordersLocationAddModal.validation.specifyAddress");
    //   allow = false;
    // }
    if (!address) {
      toast.error(t("ordersLocationAddModal.validation.addressRequired", { context: locationContext }));
      newErrors.address = t("ordersLocationAddModal.validation.specifyAddress", { context: locationContext });
      allow = false;
    }
    if (!country?.id) {
      toast.error(t("ordersLocationAddModal.validation.countryRequired"));
      newErrors.country = t("ordersLocationAddModal.validation.fillData");
      allow = false;
    }
    if (!city?.id) {
      toast.error(t("ordersLocationAddModal.validation.cityRequired"));
      newErrors.city = t("ordersLocationAddModal.validation.fillData");
      allow = false;
    }

    setErrors(newErrors);
    return allow;
  };

  const submitHandle = () => {
    if (!validationData()) {
      return;
    }

    const formData = {
      countryId: country?.id,
      cityId: city?.id,
      phoneNumber: phone ? String(phone).replace("+", "") : null,
      email: email,
      fullAddress: address,
      latLng: coordinates,
      name: name,
    };
    if (isSender) {
      formData["type"] = 0;
    } else {
      formData["type"] = 1;
    }

    setLoading(true);
    Order.getUserAddressCreate(formData)
      .then((res) => res.data)
      .then((response) => {
        toast.info(t("ordersLocationAddModal.toast.createSuccess"));
        updateContent(response);
        console.log("submit", country, response);
      })
      .catch((error) => {
        requestErrorDisplay(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleMapAddressSelect = (addressData) => {
    setAddress(addressData.shortAddress);
    setCoordinates(addressData.coordinates);
    toast.success(t("ordersLocationAddModal.toast.addressFromMapSelected") || "Адрес с карты выбран");
  };

  return (
    <ModalWindow onClose={onClose}>
      <div className={style.container}>
        <div className={style.modal} style={{flex: 2}}>
          <h3>
            {t("ordersLocationAddModal.title", { context: locationContext })} {titleEnd}
          </h3>{" "}
          <OrdersSectionItemInfoColumn>
            <CustomInput
              labelText={
                isSender ? t("addressOrder.organizationName") : t("ordersLocationAddModal.recipientNameLabel")
              }
              placeholder={
                isSender
                  ? t("addressOrder.enterOrganizationName")
                  : t("ordersLocationAddModal.recipientNamePlaceholder")
              }
              isBgGray
              value={name}
              onChangeValue={setName}
              errorText={errors?.name}
            />
          </OrdersSectionItemInfoColumn>
          {/* <OrdersSectionItemInfoColumn>
            <CustomSelect
              labelText={t("ordersLocationAddModal.countryLabel")}
              placeholder={t("ordersLocationAddModal.selectPlaceholder")}
              options={countries}
              defaultValue={country}
              onSubmit={(country) => {
                setCountry(country);
                setCity(null);
                onChangeCountry(country);
              }}
              errorText={errors?.country}
              returnObject
            />
          </OrdersSectionItemInfoColumn>
          <OrdersSectionItemInfoColumn>
            <CustomSelect
              key={city?.id}
              labelText={t("ordersLocationAddModal.cityLabel")}
              placeholder={t("ordersLocationAddModal.selectPlaceholder")}
              options={cities}
              defaultValue={city}
              onSubmit={(city) => {
                setCity(city);
                onChangeCity(city);
              }}
              isDisabled={!country}
              errorText={errors?.city}
              returnObject
            />
          </OrdersSectionItemInfoColumn> */}
          <OrdersSectionItemInfoColumn>
            {/* {COUNTRIES_WITH_MAP_ADDRESS.includes(country?.id) ? (
            <AddAddress
              labelText={t("ordersLocationAddModal.addressLabel")}
              placeholder={t("ordersLocationAddModal.addressPlaceholder")}
              setAddress={setAddress}
              errorText={errors?.address}
              isDisabled={!city}
              country={country?.name || ""}
              city={city?.name || ""}
              address={address || ""}
              setCoordinates={setCoordinates}
              setLoadingAddress={setLoadingAddress}
            /> */}
            <CustomInput
              labelText={t("ordersLocationAddModal.addressLabel", { context: locationContext })}
              placeholder={t("ordersLocationAddModal.addressPlaceholder", { context: locationContext })}
              isBgGray
              value={address}
              onChangeValue={setAddress}
              errorText={errors?.address}
              isDisabled={!country || !city}
            />
          </OrdersSectionItemInfoColumn>
          <OrdersSectionItemInfoColumn>
            {phoneCountry ? (
              <CustomPhoneInput
                labelText={t("ordersLocationAddModal.phoneLabel")}
                placeholder={t("ordersLocationAddModal.phonePlaceholder")}
                value={phone}
                onChangeValue={setPhone}
                errorText={errors?.phone}
                defaultCountry={phoneCountry.code}
                isBgGray
              />
            ) : (
              <CustomInput
                labelText={t("ordersLocationAddModal.phoneLabel")}
                placeholder={t("ordersLocationAddModal.phonePlaceholder")}
                inputType="number"
                isBgGray
                value={phone}
                onChangeValue={setPhone}
                errorText={errors?.phone}
              />
            )}

          </OrdersSectionItemInfoColumn>
          <OrdersSectionItemInfoColumn>
            <CustomInput
              labelText={t("ordersLocationAddModal.emailLabel")}
              placeholder={t("ordersLocationAddModal.emailPlaceholder")}
              inputType="text"
              onChangeValue={setEmail}
              value={email}
              errorText={errors?.email}
              isBgGray
            />
          </OrdersSectionItemInfoColumn>
          <button
            type="button"
            className={cn(style.modal_button, {
              [style.modal_button_disabled]: !country || !city,
            })}
            onClick={submitHandle}
          >
            {isLoading
              ? <Loading inBlock marginBottom={0} />
              : t("ordersLocationAddModal.buttons.save", { context: locationContext })}
          </button>
        </div>
        {/* <MapAddressPicker
          country={country?.name || ""}
          city={city?.name || ""}
          initialCoordinates={coordinates}
          onAddressSelect={handleMapAddressSelect}
          isDisabled={!city}
        /> */}
      </div>
    </ModalWindow>
  );
};

export default OrdersLocationAddModal;
